import { Page } from '../rest/base';
import { RoleStatus, V3Person } from './people';
import {
  Group,
  LearningUnitTeacherStatus,
  SchoolListView,
  SchoolStatus,
  SchoolStudentStatus,
  V3School,
} from './schools';

export const ONE_SEARCH_TYPES = {
  school: 'OneSearchSchoolEntry',
  student: 'OneSearchStudentEntry',
  teacher: 'OneSearchTeacherEntry',
  manager: 'OneSearchManagerEntry',
  person: 'OneSearchPersonEntry',
  group: 'OneSearchGroupEntry',
} as const;

export type OneSearchType = typeof ONE_SEARCH_TYPES[keyof typeof ONE_SEARCH_TYPES];

export interface OneSearchEntry {
  '@type': OneSearchType;
  score?: number | null;
}

export interface OneSearchSchoolEntry extends OneSearchEntry, SchoolListView {
  '@type': 'OneSearchSchoolEntry';
}

export interface OneSearchStudentEntry extends OneSearchEntry {
  '@type': 'OneSearchStudentEntry';
  id: number;
  person: V3Person;
  status: SchoolStudentStatus | string;
  created?: string;
  modified?: string;
  expiryDate?: string;
  school: V3School;
}

export interface OneSearchTeacherEntry extends OneSearchEntry {
  '@type': 'OneSearchTeacherEntry';
  id: number;
  person: V3Person;
  status: LearningUnitTeacherStatus | string;
  school: V3School;
}

export interface OneSearchManagerEntry extends OneSearchEntry {
  '@type': 'OneSearchManagerEntry';
  id: number;
  person: V3Person;
  school: V3School;
}

export interface OneSearchPersonEntry extends OneSearchEntry, V3Person {
  '@type': 'OneSearchPersonEntry';
}

export interface OneSearchGroupEntry extends OneSearchEntry, Group {
  '@type': 'OneSearchGroupEntry';
  school?: V3School;
  membersCount?: number;
}

export type OneSearchAnyEntry =
  | OneSearchSchoolEntry
  | OneSearchStudentEntry
  | OneSearchTeacherEntry
  | OneSearchManagerEntry
  | OneSearchPersonEntry
  | OneSearchGroupEntry;

export interface OneSearchRoleView {
  school: V3School;
  role: {
    status?: SchoolStudentStatus | LearningUnitTeacherStatus | RoleStatus | SchoolStatus | string;
    expiryDate?: string;
  };
}

export interface OneSearchPersonView {
  person: V3Person;
  managerOf: OneSearchRoleView[];
  studentOf: OneSearchRoleView[];
  teacherOf: OneSearchRoleView[];
}

export type OneSearchPeoplePage = Page<OneSearchPersonView>;
export type OneSearchSchoolsPage = Page<OneSearchSchoolEntry>;
